export const CHINA_SIMILAR_LANGUAGES = ['cmn', 'zh', 'zhen', 'yue'] as const
